import { encodeValueForHtmlAttr } from '../helpers/mini/keepJSONInAttr';
import { AlanTextChatButton } from '../model/AlanTextChatButtons';

export function renderButtons(buttons: AlanTextChatButton[]) {
    return `<div class="alan-btn__chat-buttons">
     ${buttons?.map(button => {

        const btnLabel = button.label || '';
        let resultBtn = `<div class="alan-chat__chat-btn" data-alan-button-label="${btnLabel}"`;

        if (button.sendText) {
            resultBtn += ` data-alan-button-send-text="${button.sendText}" `;
        }

        if (button.callProjectApi?.method) {
            resultBtn += ` data-alan-button-call-project-api="${button.callProjectApi?.method}" `;
        }

        if (button.callProjectApi?.data) {
            resultBtn += ` data-alan-button-call-project-api-param="${encodeValueForHtmlAttr(button.callProjectApi?.data)}" `;
        }

        if (button.setVisualState) {
            resultBtn += ` data-alan-button-set-visual-state="${encodeValueForHtmlAttr(button.setVisualState)}" `;
        }
        resultBtn += ` >${button.html || button.label}</div>`;


        return resultBtn;
    }).join('') || ''}</div>`;

}